import type { ToolResultUrl } from '@saaga/shared/interfaces/tool-result.interface'

interface QueryResult {
  unwrap: () => Promise<ToolResultUrl>
}

type PresignedUrlTrigger = (key: string) => QueryResult

/**
 * Creates a fetch function that retrieves a presigned URL for a tool result S3 key
 * using the authenticated RTK Query lazy trigger.
 */
export const createFetchPresignedUrl =
  (trigger: PresignedUrlTrigger) =>
  async (key: string): Promise<string> => {
    const result = await trigger(key).unwrap()
    return result.downloadUrl
  }
